(function() {
  if (window.__nnCardAddInit) return;
  window.__nnCardAddInit = true;

  function showToast(message) {
    var toast = document.getElementById('nn-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'nn-cart-toast';
      toast.className = 'nn-cart-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.remove('is-visible');
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    clearTimeout(toast._nnHideTimer);
    toast._nnHideTimer = setTimeout(function() {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  function isCardAddTarget(e) {
    var btn = e.target.closest('.nn-card-add, .nn-pcv2__add');
    return btn && !btn.disabled ? btn : null;
  }

  document.addEventListener('click', function(e) {
    var btn = isCardAddTarget(e);
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var hasOptions = btn.getAttribute('data-nn-has-options') === 'true';
    var productUrl = btn.getAttribute('data-nn-product-url');
    var productTitle = btn.getAttribute('data-nn-product-title');
    var variantId = btn.getAttribute('data-nn-add-to-cart');

    if (hasOptions && productUrl) {
      window.location.href = productUrl;
      return;
    }
    if (!variantId) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    var notification = document.querySelector('cart-notification');
    var drawer = document.querySelector('cart-drawer');

    var sectionsToRender = ['cart-icon-bubble'];
    if (notification) {
      sectionsToRender.push('cart-notification-product', 'cart-notification-button');
    }
    if (drawer && drawer.id) sectionsToRender.push(drawer.id);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sectionsToRender.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.status) throw new Error(data.description || data.message || 'Error');

        if (data.sections) {
          var bubbleHtml = data.sections['cart-icon-bubble'];
          if (bubbleHtml) {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble) {
              var tmp = document.createElement('div');
              tmp.innerHTML = bubbleHtml;
              var newBubble = tmp.querySelector('#cart-icon-bubble') || tmp.firstElementChild;
              if (newBubble) bubble.innerHTML = newBubble.innerHTML;
            }
          }
          if (drawer && data.sections[drawer.id]) {
            drawer.renderContents({ sections: data.sections, items: [] });
          }
        }

        try {
          if (window.PUB_SUB_EVENTS && window.publish) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'nn-card-add', productVariantId: variantId });
          }
        } catch (_) {}

        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.disabled = false;
        setTimeout(function() { btn.classList.remove('is-added'); }, 1500);

        var fallbackToast = function() {
          showToast(productTitle ? '✓ ' + productTitle + ' agregado al carrito' : '✓ Agregado al carrito');
        };

        if (notification && data.key) {
          try {
            notification.renderContents(data);
          } catch (renderErr) {
            console.warn('[nn-card-add] cart-notification render failed', renderErr);
            fallbackToast();
          }
        } else {
          fallbackToast();
        }
      })
      .catch(function(err) {
        console.warn('[nn-card-add]', err);
        btn.classList.remove('is-loading');
        btn.disabled = false;
        if (productUrl) window.location.href = productUrl;
      });
  }, true);
})();
